<template>
  <v-content
    width="360px"
  >
    <div
      width="360px"
    >
    <allergens-filter v-if="allergenFilters" />
      <!-- <a
        v-if="!item.Menus || item.Menus.length === 0"
        @click="handleMenuClick(item)"
      >
        <menu-header
          :name="item.Name"
        />
      </a> -->
      <v-expansion-panels
        width="360px"
        :multiple="false"
        class="list-group-item"
      >
        <v-expansion-panel
          v-for="(item, i) in data"
          :key="i"
          :style="{
            'background-color': isSecundary ? BGColorSecundary : BGColor, 
          }"
        >
          <v-expansion-panel-header
            v-slot="{ open }"
            v-if="!item.HideDesktop || item.HideDesktop === 0"
            expand-icon=""
            style="padding: 0;"
            :style="{ 
              'border-radius': `0 0 0 0`,
              'cursor': isSimulation && !isSecundary ? 'move !important' : 'pointer !important',
              'font-family': isSecundary ? FontSecundary : Font,
              'font-size': isSecundary ? `${FontSizeSecundary}px` : `${FontSize}px`,
              'background-color': isSecundary ? BGColorSecundary : BGColor, 
              'color': isSecundary ? ColorSecundary : Color, 
              'background-image': ((isSecundary && withGradientSubmenu) || (!isSecundary && withGradient)) ? 'linear-gradient(to top, rgba(128, 128, 128, 0.0), rgba(0, 0, 0, 0.2))' : '',
              'border-bottom': withLine ? `0.5px solid ${getColor()}` : '',
              'border-top': withLine ? `0.5px solid ${getColor()}` : ''
            }"
            @click="handleMenuClick(item)"
          >
            <menu-header
              :name="item.Name"
            />
          </v-expansion-panel-header>
          <v-expansion-panel-content
            v-if="item.Menus"
          >
            <a
              v-for="(submenu, i) in item.Menus.filter(x => !x.HideDesktop)"
              :key="i"
              @click="handleMenuClick(submenu)"
            >
              <menu-header
                :name="submenu.Name"
                :isSecundary="true"
              />
            </a>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- <div
        v-for="(submenu, i) in item.Menus"
        :key="i"
      >
        <a @click="handleMenuClick(submenu)">
          <menu-header
            :name="submenu.Name"
            :isSecundary="true"
          />
        </a>
      </div> -->
    </div>
  </v-content>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import api from '@/services/api'
  import constants from '@/constants'
  import MenuHeader from '../MenuHeader'
  import AllergensFilter from '../../mobile/customMenu/items/foodDrink/AllergensFilter'
  export default {
    components: {
      AllergensFilter,
      MenuHeader,
    },
    props: {
      data: {
        type: Array,
        required: false,
        default: null
      },
      onMenuChange: {
        type: Function,
        required: true
      },
      allergenFilters: {
        type: [Boolean, Number],
        default: false,
      },
    },
    data: () => ({
      isSecundary: false,
    }),
    computed: {
      ...mapState('app',['withLine', 'withGradient', 'withGradientSubmenu','BGColor', 'Color', 'BGColorSecundary', 'ColorSecundary', 'GlobalFont', 'FontSecundary', 'FontSizeSecundary', 'Font', 'FontSize', ]),      
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
    },
    mounted () {
      
    },
    methods: {
      handleMenuClick (menu) {
        if (menu.WebAppAsLink) {
          let url = ''
            if (menu.WebAppAsContentDomain.indexOf('.') > 0) url = menu.WebAppAsContentDomain
            else {
              url = `${window.location.protocol}//${menu.WebAppAsContentDomain}.${process.env.VUE_APP_API_URL}`
              url += '#/?back='+utils.getDomain()
              if (this.locale !== 'es') url += '&locale=' + this.locale
            }
            const dfileResp = this.$session.get('dfilesResponse')
          url = url.replace('@#@', '?')
          window.location.href = `${url}${dfileResp ? '&dfileResp='+dfileResp : ''}`
        } else {
          if (!menu.IsMenuWithSubmenu) this.onMenuChange(menu)
        }
        this.handleSetStats(menu)
      },
      getColor () {
        if (this.isSecundary) {
          if (this.ColorSecundary && this.ColorSecundary.length >= 7) {
            return this.ColorSecundary.substring(0, 7).concat('4d')
          }
          return this.ColorSecundary
        } else {
          if (this.Color && this.Color.length >= 7) {
            return this.Color.substring(0, 7).concat('4d')
          }
          return this.Color
        }
      },
      handleSetStats (menu) {
        // añadimos los registros de accesos públicos
        api.setStats('stats', menu.ID )
          .then(response => {
          })
          .catch(error => {
            console.log('error', error)
          })
      },
    }
  }
</script>
<style lang="scss" scoped>
  
</style>
